import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { Select } from 'antd';
import { allApkTypes } from 'appConstants';
import { ApkContext, IApkContext } from 'modules/FirmwareAndApp/Apk/Apk/apkState/apkContext';
import { useTranslation } from 'react-i18next';
import style from './ApkTypeSelect.module.scss';

const { Option } = Select;

const ApkTypeSelect: React.FC = () => {
	const { setIDApkType, IDSelectedApkType } = useContext<IApkContext>(ApkContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { t } = useTranslation('listing');

	return (
		<div className={style.container} data-test="ApkTypeSelect">
			<Text
				translationNameSpace="listing"
				translationKey="applicationApkTypeLabel"
				theme="neutralLight"
				size="xs"
			/>
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDApkType}
				value={IDSelectedApkType}
				listItemHeight={allApkTypes.length}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{allApkTypes.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{allApkTypes.map((el) => (
							<Option className={style.listItem} value={el.apkTypeID} key={el.apkTypeID}>
								{el.apkTypeName}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default ApkTypeSelect;
